import { render, staticRenderFns } from "./EventSearch.vue?vue&type=template&id=c5f4c4b8&scoped=true"
import script from "./EventSearch.vue?vue&type=script&lang=ts"
export * from "./EventSearch.vue?vue&type=script&lang=ts"
import style0 from "./EventSearch.vue?vue&type=style&index=0&id=c5f4c4b8&prod&scoped=true&lang=scss"
import style1 from "./EventSearch.vue?vue&type=style&index=1&id=c5f4c4b8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5f4c4b8",
  null
  
)

export default component.exports